<template>
  <div class="sm-datepicker-wrap" :class="{disabled, 'higher-index': higherIndex}">
    <label
      v-if="label"
      class="sm-small"
    >{{label}}</label>
    <datepicker-block 
      v-model="value"
      valueType="format"
      class="sm-datepicker"
      :class="{'no-calendar': value && clearable}"
      input-class="sm-datepicker__input"
      :lang="lang"
      :type="type"
      :first-day-of-week="7"
      :append-to-body="false"
      :inline="inline"
      :placeholder="placeholder"
      :clearable="clearable"
      :disabled-date="disablePeriod"
      @input="changeDate"
      v-bind="open ? {
        open: open,
      } : {}"
    >
      <template slot="icon-calendar">
        <include-svg :name="'icon-calendar'" />
      </template>
      <template slot="input">
        <span
          v-if="value"
          class="sm-datepicker__input"
        >{{value | moment('MMMM D, YYYY')}}</span>
        <span
          v-else
          class="sm-datepicker__input disabled"
        >{{placeholder}}</span>
      </template>
    </datepicker-block>
  </div>
</template>

<script>
import Datepicker from 'vue2-datepicker';

export default {
  name: 'datepicker-wrap',
  components: {
    'datepicker-block': Datepicker
  },
  props: {
    val: {
      default: ''
    },
    outerVal: {
      default: ''
    },
    type: {
      type: String,
      default: 'date'
    },
     isToLastDay: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Select date'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    notBefore: {
      default: null
    },
    notAfter: {
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    disabledWeekdays: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    higherIndex: {
      type: Boolean,
      default: false,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lang: {
        days: ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA']
      },
      value: '',
      disablePeriod: () => null
    }
  },
  created() {
    this.value = this.val;

    if (this.notBefore)
      this.disablePeriod = this.notBeforeDate;
    else if (this.notAfter)
      this.disablePeriod = this.notAfterDate;
    else if (this.disabledWeekdays.length)
      this.disablePeriod = this.disableWeekdays;
  },
  methods: {
    notBeforeDate(date) {
      return this.$moment(date) < this.$moment(this.notBefore) || this.disableWeekdays(date);
    },
    notAfterDate(date) {
      return this.$moment(date) > this.$moment(this.notAfter) || this.disableWeekdays(date);
    },
    getLastDayOfMonth(d) {
      let date = d;
      if (!d) date = new Date();
      if(date) 
        return this.$moment(new Date(date).setMonth(new Date(date).getMonth() + 1, 0)).format('YYYY-MM-DD');
    },
    changeDate() {
      this.$emit('input', this.value && this.isToLastDay ? this.getLastDayOfMonth(this.value) : ( this.value ? this.value : ''));
    },
    disableWeekdays(value) {
      let date = new Date(value);
      let weekDay = date.getDay();

      return this.disabledWeekdays.includes(weekDay);
    },
  },
  watch: {
    // val(v) {
    //   this.value = v;
    // },
    outerVal(v) {
      this.value = v;
    },
    notBefore(v) {
      if (v)
        this.disablePeriod = this.notBeforeDate;
      else
        this.disablePeriod = () => null;
    },
    notAfter(v) {
      if (v)
        this.disablePeriod = this.notAfterDate;
      else
        this.disablePeriod = () => null;
    }
  }
}
</script>